export default {"src":"/_next/static/media/identity.8da3d27a.svg","height":25,"width":242};